import { render, staticRenderFns } from "./PayPerView.vue?vue&type=template&id=4dd27d8e"
import script from "./PayPerView.vue?vue&type=script&lang=js"
export * from "./PayPerView.vue?vue&type=script&lang=js"
import style0 from "./PayPerView.vue?vue&type=style&index=0&id=4dd27d8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports